// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6907e835","703":"8dc19e5b","923":"e9336cae"}[chunkId] + ".chunk.js";
};